import { TariffViewModel } from '@common/model/billing/tariff/view';
import { secondsInMonth } from 'date-fns';
import { getPerSecondPrice } from './getPerSecondPrice';

export const getTariffPerMonthPrice = (tariff: TariffViewModel) => {
  return Math.round(getPerSecondPrice(tariff) * secondsInMonth);
};
